import { MarketMapState } from './types';
import { MarketMapTypeAction } from './actions';

const initialState: MarketMapState = {
  loadedAreas: [],
};

export function marketMapReducer(state: MarketMapState = initialState, action: MarketMapTypeAction): MarketMapState {
  switch (action.type) {
    case 'MARKET_MAP_VIEWING_BOUNDS_CHANGED':
      return {
        ...state,
        currentBounds: action.data,
      };

    case 'MARKET_MAP_AREAS_LOADED':
      return {
        ...state,
        loadedAreas: action.data,
      };

    default:
      return state;
  }
}
